<section class="hero" id="home">
  <!-- Background grid decoration -->
  <div class="hero__grid"></div>
  <!-- Decorative compass rose background -->
  <div class="hero__compass-bg">
    <svg viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg">
      <polygon points="100,5 104,100 100,82 96,100" fill="white" opacity="0.07"/>
      <polygon points="100,195 104,100 100,118 96,100" fill="white" opacity="0.04"/>
      <polygon points="195,100 100,96 118,100 100,104" fill="white" opacity="0.04"/>
      <polygon points="5,100 100,96 82,100 100,104" fill="white" opacity="0.04"/>
      <polygon points="160,40 102,100 105,95" fill="white" opacity="0.03"/>
      <polygon points="40,40 98,100 95,95" fill="white" opacity="0.03"/>
      <polygon points="160,160 102,100 105,105" fill="white" opacity="0.03"/>
      <polygon points="40,160 98,100 95,105" fill="white" opacity="0.03"/>
      <circle cx="100" cy="100" r="40"  stroke="rgba(255,255,255,0.06)" stroke-width="1" fill="none"/>
      <circle cx="100" cy="100" r="60"  stroke="rgba(255,255,255,0.04)" stroke-width="1" fill="none"/>
      <circle cx="100" cy="100" r="80"  stroke="rgba(255,255,255,0.03)" stroke-width="1" fill="none"/>
      <circle cx="100" cy="100" r="95"  stroke="rgba(255,255,255,0.02)" stroke-width="1" fill="none"/>
      <circle cx="100" cy="100" r="8"   fill="rgba(255,255,255,0.06)"/>
    </svg>
  </div>
  <!-- Gradient blobs -->
  <div class="blob blob-1"></div>
  <div class="blob blob-2"></div>

  <div class="container hero__inner">
    <div class="hero__content">
      <span class="section-tag">{{ t().hero_tag }}</span>
      <h1 class="hero__title">
        {{ t().hero_title_1 }}<br>
        {{ t().hero_title_2 }}<br>
        <span>{{ t().hero_title_3 }}</span>
      </h1>
      <p class="hero__subtitle">{{ t().hero_subtitle }}</p>

      <p class="hero__tagline">{{ t().hero_tagline }}</p>

      <div class="hero__stats">
        <div class="stat">
          <span class="stat-icon">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
              <path d="M12 2L2 7l10 5 10-5-10-5z" stroke="#0066cc" stroke-width="1.5" stroke-linejoin="round"/>
              <path d="M2 17l10 5 10-5" stroke="#0066cc" stroke-width="1.5" stroke-linejoin="round"/>
              <path d="M2 12l10 5 10-5" stroke="#0066cc" stroke-width="1.5" stroke-linejoin="round"/>
            </svg>
          </span>
          <span class="stat-label">{{ t().hero_stat1_label }}</span>
        </div>
        <div class="stat">
          <span class="stat-icon">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
              <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" stroke="#0066cc" stroke-width="1.5"/>
              <circle cx="12" cy="12" r="3" stroke="#0066cc" stroke-width="1.5"/>
            </svg>
          </span>
          <span class="stat-label">{{ t().hero_stat2_label }}</span>
        </div>
        <div class="stat">
          <span class="stat-icon">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
              <rect x="2" y="2" width="20" height="20" rx="3" stroke="#0066cc" stroke-width="1.5"/>
              <path d="M8 12l3 3 5-5" stroke="#0066cc" stroke-width="1.5" stroke-linecap="round"/>
            </svg>
          </span>
          <span class="stat-label">{{ t().hero_stat3_label }}</span>
        </div>
        <div class="stat">
          <span class="stat-icon">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
              <path d="M12 2v20M2 12h20" stroke="#0066cc" stroke-width="1.5" stroke-linecap="round"/>
              <circle cx="12" cy="12" r="4" stroke="#0066cc" stroke-width="1.5"/>
            </svg>
          </span>
          <span class="stat-label">{{ t().hero_stat4_label }}</span>
        </div>
        <div class="stat">
          <span class="stat-icon">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
              <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2" stroke="#0066cc" stroke-width="1.5" stroke-linecap="round"/>
              <circle cx="9" cy="7" r="4" stroke="#0066cc" stroke-width="1.5"/>
              <path d="M23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75" stroke="#0066cc" stroke-width="1.5" stroke-linecap="round"/>
            </svg>
          </span>
          <span class="stat-label">{{ t().hero_stat5_label }}</span>
        </div>
        <div class="stat">
          <span class="stat-icon">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
              <circle cx="12" cy="12" r="10" stroke="#0066cc" stroke-width="1.5"/>
              <path d="M12 6v6l4 2" stroke="#0066cc" stroke-width="1.5" stroke-linecap="round"/>
            </svg>
          </span>
          <span class="stat-label">{{ t().hero_stat6_label }}</span>
        </div>
      </div>

      <div class="hero__actions">
        <a href="#solutions" class="btn-primary">
          {{ t().hero_cta_primary }}
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M3 8h10M9 4l4 4-4 4" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </a>
        <a href="#contact" class="btn-outline">{{ t().hero_cta_secondary }}</a>
      </div>
    </div>

    <div class="hero__visual">
      <div class="monitor-card">
        <div class="monitor-header">
          <div class="monitor-dot red"></div>
          <div class="monitor-dot yellow"></div>
          <div class="monitor-dot green"></div>
          <span>{{ t().hero_monitor_label }}</span>
        </div>
        <div class="monitor-body">
          <!-- Radar animation -->
          <div class="radar">
            <div class="radar-ring r1"></div>
            <div class="radar-ring r2"></div>
            <div class="radar-ring r3"></div>
            <div class="radar-sweep"></div>
            <div class="radar-dot d1"></div>
            <div class="radar-dot d2"></div>
            <div class="radar-dot d3"></div>
          </div>
          <!-- Status indicators -->
          <div class="status-list">
            <div class="status-item active">
              <span class="status-dot"></span>
              <span>{{ t().hero_cam_label }}</span>
              <strong>247 / 250</strong>
            </div>
            <div class="status-item active">
              <span class="status-dot"></span>
              <span>{{ t().hero_iot_label }}</span>
              <strong>{{ t().hero_iot_value }}</strong>
            </div>
            <div class="status-item warning">
              <span class="status-dot"></span>
              <span>{{ t().hero_alert_label }}</span>
              <strong>{{ t().hero_alert_value }}</strong>
            </div>
          </div>
        </div>
      </div>

      <!-- Floating badges -->
      <div class="badge badge-1">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
          <path d="M12 2L2 7l10 5 10-5-10-5z" stroke="#0066cc" stroke-width="1.5" stroke-linejoin="round"/>
          <path d="M2 17l10 5 10-5" stroke="#0066cc" stroke-width="1.5" stroke-linejoin="round"/>
          <path d="M2 12l10 5 10-5" stroke="#0066cc" stroke-width="1.5" stroke-linejoin="round"/>
        </svg>
        <span>{{ t().hero_badge1 }}</span>
      </div>
      <div class="badge badge-2">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
          <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" stroke="#22c55e" stroke-width="1.5"/>
          <circle cx="12" cy="12" r="3" stroke="#22c55e" stroke-width="1.5"/>
        </svg>
        <span>{{ t().hero_badge2 }}</span>
      </div>
    </div>
  </div>

  <!-- Scroll indicator -->
  <div class="scroll-indicator">
    <span>{{ t().hero_scroll }}</span>
    <div class="scroll-line"></div>
  </div>
</section>
